export default "## I'm a staging article\n\nI'm not indexed until we say so ;)\n";